import React, { Suspense } from "react";
import { Redirect, Switch, Route, HashRouter } from "react-router-dom";
import { Spin } from "antd";
import queryString from "query-string";
import Layout from "@pages/Layout";
import LayoutScreen from "../pages/screen/Layout";
import Login from "@pages/login"; // 登陆
import StationManger from "@pages/serviceManger/station"; // 站点管理
import newStationManger from "@pages/serviceManger/station/newStation"; // 新增站点
import AI from "@pages/AI"; // ai分析
import Warn from "@pages/warn"; // 告警与预警
import WarnSetting from "@pages/warn/warnSetting"; // 告警设置
import AddAsset from "@pages/assetsmana"; // 设备录入
import SearchList from "@pages/assetsmana/list"; // 设备查询
import SysMsg from "@pages/message/sysmsg"; // 系统消息
import Dayreport from "@pages/analyse/dayreport"; // 日报表
import Monthreport from "@pages/analyse/monthreport"; // 月报表
import Energyreport from "@pages/analyse/energyreport";
import Yearreport from "@pages/analyse/yearreport"; // 年报表
import Ecreport from "@pages/analyse/yearreport/ecreport";
import Wqreport from "@pages/analyse/yearreport/wqreport";
import Yjlcreport from "@pages/analyse/yearreport/yjlcreport";
import DosageAnalysis from "@pages/analyse/dosageAnalysis";
import RevenueAnalysis from "@pages/analyse/revenue";
import MoneyUseAnalysis from "@pages/analyse/moneyUse";
import PatrolAnalysis from "@pages/analyse/patrol";
import AlarmHandlerAnalysis from "@pages/analyse/alarmHandler";
import CompositeEval from "@pages/compositeEval";
import GIS from "@pages/stationManagement/GIS"; // gis地图
import TechProcess from "@pages/stationManagement/techProcess"; // 工艺流程
import SettingProcess from "@pages/stationManagement/settingProcess"; // 工艺流程设置界面
import Bim from "@pages/stationManagement/bim"; //bim
import User from "@pages/userManger";
import Screen from "@pages/screen/view"; // 大屏
import RoleManger from "@pages/serviceManger/role"; // 角色管理
import DepartmentManger from "@pages/serviceManger/department"; // 部门管理
import departmentPerson from "@pages/serviceManger/departmentPerson"; // 部门人员管理
import Dict from "@pages/serviceManger/dict";
import FactoryProgress from "@pages/stationManagement/factoryProgress"; // 厂区工艺流程
import ApprovalProcess from "@pages/inspectionnew/approvalProcess"; // 审批流程
import Pedding from "@pages/inspectionnew/pedding"; // 待办事项
import Inspection from "@pages/inspectionnew"; // 巡检模版
import Plan from "@pages/inspectionnew/plans"; // 巡检计划
import Defects from "@pages/inspectionnew/defects"; // 缺陷
import DispatchCenter from "@pages/inspectionnew/dispatchCenter"; // 调度中心
import Order from "@pages/inspectionnew/order"; // 工单
import Task from "@pages/inspectionnew/task"; // 任务
import Standard from "@pages/inspectionnew/standard"; //标准
import DefectsLevel from "@pages/inspectionnew/defectslevel"; //缺陷等级
import Instruct from "@pages/inspectionnew/instruct"; //指令单
import InstructLeak from "@pages/inspectionnew/instructleak"; // 指令单漏检
import OrderLeak from "@pages/inspectionnew/orderleak"; // 工单漏检
import UpkeepTaskLeak from "@pages/inspectionnew/upkeeptaskleak"; // 保养任务漏检
import Taskleak from "@pages/inspectionnew/taskleak"; //巡检任务(漏检)
import Upkeep from "@pages/inspectionnew/upkeep"; //保养
import UpkeepPlan from "@pages/inspectionnew/upkeepplan"; //保养计划
import UpkeepTask from "@pages/inspectionnew/upkeeptask"; //保养任务
import upkeepTemplate from "@pages/inspectionnew/upkeepTemplate/upkeepTemplate"; //保养模板
import SingleLogin from "@pages/SingleLogin";
import MenuRole from "@pages/serviceManger/menu"; // 菜单权限
import FlowCategory from "@pages/FlowConfig/FlowCategory"; // 流程分类
import FlowTmplate from "@pages/FlowConfig/FlowTmplate"; // 流程模板
import FlowDesign from "@pages/FlowConfig/FlowDesign"; // 流程设计
import SysMessage from "@pages/SysMessage"; // 消息模块
import InspectMode from "@pages/inspect/model"; // 巡检模版
import InspectStandard from "@pages/inspect/standard"; // 巡检标准
import InspectStandardAdd from "@pages/inspect/standard/add"; // 巡检标准
import DosingCarbon from "@pages/dosing/carbon";
import DosingPhosphorus from "@pages/dosing/phosphorus";
import Reflow from "@pages/dosing/reflow";
import ProcessUnitProcessFlow from "@pages/stationManagement/processUnitProcessFlow";
import EquipList from "@pages/iot/equip-list";
import ProduceMonitor from "@pages/stationManagement/produceMonitor";
import DeviceHealth from "@pages/device/health";
import DeviceTaiZhang from "@pages/device/taizhang";
import KnowledgeBase from "@pages/device/knowledgeBase";
import BusinessType from "@pages/device/businessType";
import SupplierCategory from "@pages/device/supplierCategory";
import DeviceSupplier from "@pages/device/supplier";
import StoreManage from "@pages/device/storeManage";
import SpareParts from "@pages/device/spareParts";
import Warehousing from "@pages/device/warehousing";
import Outbound from "@pages/device/outbound";
import InspectionReport from "@pages/inspectionnew/report";
import EnergyAnalysis from "@pages/energyAnalysis";
import EquipmentProcess from "@pages/stationManagement/equipmentProcess";
import Performance from "@pages/performance";
import InspectionnewMap from "@pages/inspectionnew/map";
import InspectionnewTeam from "@pages/inspectionnew/team";
import Pandect from "@pages/energyAnalysis/pandect";
import Monomer from "@pages/energyAnalysis/monomer";
import Collectivity from "@pages/energyAnalysis/collectivity";
import Collocate from "@pages/energyAnalysis/collocate";
import Classify from "@pages/energyAnalysis/classify";
import ThreeDimensional from "@pages/ThreeDimensional";
import VideoSurveillance from "@pages/stationManagement/videoSurveillance";
import ProcessUnit from "@pages/stationManagement/processUnit";

/**
 *
 * @param Component
 * @param props
 * @returns {*}
 * 路由拦截
 */

const onEnter = (Component, props) => {
  if (
    props.location.pathname == "/login" ||
    props.location.pathname == "/singleLogin"
  ) {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("userInfo");
    return <Component {...props} />;
  }
  const searchParams = queryString.parse(props.location.search);
  if (props.location.pathname != "/singleLogin") {
    if (
      !sessionStorage.getItem("token") &&
      (!searchParams.onlyCon || searchParams.onlyCon != "yes")
    ) {
      return <Redirect to="/login" />;
    }
  }
  if (props.location.pathname == "/screen") {
    return (
      <LayoutScreen>
        <Component {...props} />
      </LayoutScreen>
    );
  } else {
    return (
      <Layout>
        <Component {...props} />
      </Layout>
    );
  }
};

/**
 *
 * @returns {*}
 * @constructor
 * 路由管理
 */
const Routes = () => (
  <Suspense fallback={<Spin className="style-spin" />}>
    <HashRouter>
      <Switch>
        {/* 故障告警 */}
        <Route
          path={"/warn/index"}
          exact
          render={(props) => onEnter(Warn, props)}
        />
        <Route
          path={"/warn/setting"}
          exact
          render={(props) => onEnter(WarnSetting, props)}
        />
        {/* 资产管理 */}
        <Route
          path={"/assetsmana/addasset"}
          exact
          render={(props) => onEnter(AddAsset, props)}
        />
        <Route
          path={"/assetsmana/searchlist"}
          exact
          render={(props) => onEnter(SearchList, props)}
        />
        <Route
          path={"/systemSeting/station"}
          exact
          render={(props) => onEnter(StationManger, props)}
        />
        <Route
          path={"/systemSeting/station/addstation"}
          exact
          render={(props) => onEnter(newStationManger, props)}
        />
        <Route
          path={"/systemSeting/user"}
          exact
          render={(props) => onEnter(User, props)}
        />
        <Route
          path={"/systemSeting/sysmsg"}
          exact
          render={(props) => onEnter(SysMsg, props)}
        />
        <Route
          path={"/analyse/dayreport"}
          exact
          render={(props) => onEnter(Dayreport, props)}
        />
        <Route
          path={"/analyse/monthreport"}
          exact
          render={(props) => onEnter(Monthreport, props)}
        />
        <Route
          path={"/analyse/energyreport"}
          exact
          render={(props) => onEnter(Energyreport, props)}
        />
        <Route
          path={"/analyse/creport"}
          exact
          render={(props) => onEnter(Yearreport, props)}
        />
        <Route
          path={"/analyse/creport/ecreport"}
          exact
          render={(props) => onEnter(Ecreport, props)}
        />
        <Route
          path={"/analyse/creport/wqreport"}
          exact
          render={(props) => onEnter(Wqreport, props)}
        />
        <Route
          path={"/analyse/creport/yjlcreport"}
          exact
          render={(props) => onEnter(Yjlcreport, props)}
        />
        <Route
          path={"/analyse/dosageAnalysis"}
          exact
          render={(props) => onEnter(DosageAnalysis, props)}
        />
        <Route
          path={"/analyse/revenue"}
          exact
          render={(props) => onEnter(RevenueAnalysis, props)}
        />
        <Route
          path={"/analyse/moneyUse"}
          exact
          render={(props) => onEnter(MoneyUseAnalysis, props)}
        />
        <Route
          path={"/analyse/patrol"}
          exact
          render={(props) => onEnter(PatrolAnalysis, props)}
        />
        <Route
          path={"/analyse/alarmHandler"}
          exact
          render={(props) => onEnter(AlarmHandlerAnalysis, props)}
        />
        <Route
          path={"/compositeEval"}
          exact
          render={(props) => onEnter(CompositeEval, props)}
        />
        <Route
          path={"/stationManagement/GIS"}
          exact
          render={(props) => onEnter(GIS, props)}
        />
        <Route
          path={"/stationManagement/factoryProgress"}
          exact
          render={(props) => onEnter(FactoryProgress, props)}
        />
        <Route
          path={"/stationManagement/settingProcessShow"}
          exact
          render={(props) => onEnter(TechProcess, props)}
        />
        <Route
          path={"/systemSeting/settingProcess"}
          exact
          render={(props) => onEnter(SettingProcess, props)}
        />
        <Route
          path={"/stationManagement/processUnitProcessFlow"}
          exact
          render={(props) => onEnter(ProcessUnitProcessFlow, props)}
        />
        <Route
          path={"/stationManagement/bim"}
          exact
          render={(props) => onEnter(Bim, props)}
        />
        <Route
          path={"/analysis/earlywarning"}
          exact
          render={(props) => onEnter(AI, props)}
        />
        <Route
          path={"/login"}
          exact
          render={(props) => onEnter(Login, props)}
        />
        <Route
          path={"/singleLogin"}
          exact
          render={(props) => onEnter(SingleLogin, props)}
        />
        <Route
          path={"/screen"}
          exact
          render={(props) => onEnter(Screen, props)}
        />
        <Route
          path={"/sysMessage"}
          exact
          render={(props) => onEnter(SysMessage, props)}
        />
        {/* <Route
          path={"/inspection/model"}
          exact
          render={(props) => onEnter(Inspection, props)}
        />
        <Route
          path={"/inspection/plan"}
          exact
          render={(props) => onEnter(Plan, props)}
        />
        <Route
          path={"/inspection/defects"}
          exact
          render={(props) => onEnter(Defects, props)}
        />
        <Route
          path={"/inspection/order"}
          exact
          render={(props) => onEnter(Order, props)}
        />
        <Route
          path={"/inspection/task"}
          exact
          render={(props) => onEnter(Task, props)}
        /> */}
        <Route
          path={"/inspection_new/approvalProcess"}
          exact
          render={(props) => onEnter(ApprovalProcess, props)}
        />
        <Route
          path={"/inspection_new/pedding"}
          exact
          render={(props) => onEnter(Pedding, props)}
        />
        <Route
          path={"/inspection_new/model"}
          exact
          render={(props) => onEnter(Inspection, props)}
        />
        <Route
          path={"/inspection_new/plan_new"}
          exact
          render={(props) => onEnter(Plan, props)}
        />
        <Route
          path={"/inspection_new/defects"}
          exact
          render={(props) => onEnter(Defects, props)}
        />
        <Route
          path={"/inspection_new/dispatch_center"}
          exact
          render={(props) => onEnter(DispatchCenter, props)}
        />
        <Route
          path={"/inspection_new/order"}
          exact
          render={(props) => onEnter(Order, props)}
        />
        <Route
          path={"/inspection_new/task"}
          exact
          render={(props) => onEnter(Task, props)}
        />
        <Route
          path={"/inspection_new/standard"}
          exact
          render={(props) => onEnter(Standard, props)}
        />
        <Route
          path={"/inspection_new/defect_level"}
          exact
          render={(props) => onEnter(DefectsLevel, props)}
        />
        <Route
          path={"/inspection_new/task_leak"}
          exact
          render={(props) => onEnter(Taskleak, props)}
        />
        <Route
          path={"/inspection_new/instruct"}
          exact
          render={(props) => onEnter(Instruct, props)}
        />
        <Route
          path={"/inspection_new/upkeep_standard"}
          exact
          render={(props) => onEnter(Upkeep, props)}
        />
        <Route
          path={"/inspection_new/upkeep_plan"}
          exact
          render={(props) => onEnter(UpkeepPlan, props)}
        />
        <Route
          path={"/inspection_new/upkeep_task"}
          exact
          render={(props) => onEnter(UpkeepTask, props)}
        />
        <Route
          path={"/inspection_new/upkeep_template"}
          exact
          render={(props) => onEnter(upkeepTemplate, props)}
        />
        <Route
          path={"/inspection_new/instructleak"}
          exact
          render={(props) => onEnter(InstructLeak, props)}
        />
        <Route
          path={"/inspection_new/orderleak"}
          exact
          render={(props) => onEnter(OrderLeak, props)}
        />
        <Route
          path={"/inspection_new/upkeeptaskleak"}
          exact
          render={(props) => onEnter(UpkeepTaskLeak, props)}
        />
        <Route
          path={"/inspection_new/team"}
          exact
          render={(props) => onEnter(InspectionnewTeam, props)}
        />
        <Route
          path={"/systemSeting/role"}
          exact
          render={(props) => onEnter(RoleManger, props)}
        />
        <Route
          path={"/systemSeting/menu"}
          exact
          render={(props) => onEnter(MenuRole, props)}
        />
        <Route
          path={"/flowConfig/flowCategory"}
          exact
          render={(props) => onEnter(FlowCategory, props)}
        />
        <Route
          path={"/flowConfig/flowTmplate"}
          exact
          render={(props) => onEnter(FlowTmplate, props)}
        />
        <Route
          path={"/flowConfig/flowDesign"}
          exact
          render={(props) => onEnter(FlowDesign, props)}
        />
        <Route
          path={"/systemSeting/department"}
          exact
          render={(props) => onEnter(DepartmentManger, props)}
        />
        <Route
          path={"/systemSeting/departmentPerson"}
          exact
          render={(props) => onEnter(departmentPerson, props)}
        />
        <Route
          path={"/systemSeting/dict"}
          exact
          render={(props) => onEnter(Dict, props)}
        />
        {/* 第二版 巡检 */}
        <Route
          path={"/inspect/model"}
          exact
          render={(props) => onEnter(InspectMode, props)}
        />
        <Route
          path={"/inspect/standard"}
          exact
          render={(props) => onEnter(InspectStandard, props)}
        />
        <Route
          path={"/inspect/standard/add"}
          exact
          render={(props) => onEnter(InspectStandardAdd, props)}
        />
        <Route
          path={"/dosing/carbon"}
          exact
          render={(props) => onEnter(DosingCarbon, props)}
        />
        <Route
          path={"/dosing/phosphorus"}
          exact
          render={(props) => onEnter(DosingPhosphorus, props)}
        />
        <Route
          path={"/dosing/reflow"}
          exact
          render={(props) => onEnter(Reflow, props)}
        />
        <Route
          path={"/iot/equip-list"}
          exact
          render={(props) => onEnter(EquipList, props)}
        />
        <Route
          path={"/monitorCenter/produceMonitor"}
          exact
          render={(props) => onEnter(ProduceMonitor, props)}
        />
        <Route
          path={"/monitorCenter/videoSurveillance"}
          exact
          render={(props) => onEnter(VideoSurveillance, props)}
        />
        <Route
          path={"/device/health"}
          exact
          render={(props) => onEnter(DeviceHealth, props)}
        />
        <Route
          path={"/device/deviceTaiZhang"}
          exact
          render={(props) => onEnter(DeviceTaiZhang, props)}
        />
        <Route
          path={"/device/knowledgeBase"}
          exact
          render={(props) => onEnter(KnowledgeBase, props)}
        />
        <Route
          path={"/device/businessType"}
          exact
          render={(props) => onEnter(BusinessType, props)}
        />
        <Route
          path={"/device/supplierCategory"}
          exact
          render={(props) => onEnter(SupplierCategory, props)}
        />
        <Route
          path={"/device/storeManage"}
          exact
          render={(props) => onEnter(StoreManage, props)}
        />
        <Route
          path={"/device/spareParts"}
          exact
          render={(props) => onEnter(SpareParts, props)}
        />
        <Route
          path={"/device/supplier"}
          exact
          render={(props) => onEnter(DeviceSupplier, props)}
        />
        <Route
          path={"/device/warehousing"}
          exact
          render={(props) => onEnter(Warehousing, props)}
        />
        <Route
          path={"/device/outbound"}
          exact
          render={(props) => onEnter(Outbound, props)}
        />
        <Route
          path={"/inspection_new/report"}
          exact
          render={(props) => onEnter(InspectionReport, props)}
        />
        <Route
          path={"/inspection_new/map"}
          exact
          render={(props) => onEnter(InspectionnewMap, props)}
        />
        {/* 能耗分析 */}
        <Route
          path={"/operation/energyreport"}
          exact
          render={(props) => onEnter(EnergyAnalysis, props)}
        />
        <Route
          path={"/systemSeting/equipmentProcess"}
          exact
          render={(props) => onEnter(EquipmentProcess, props)}
        />
        {/* 绩效分析 */}
        <Route
          path={"/operation/performance"}
          exact
          render={(props) => onEnter(Performance, props)}
        />
        {/* 能耗总览 */}
        <Route
          path={"/operation/pandect"}
          exact
          render={(props) => onEnter(Pandect, props)}
        />
        {/* 单体能耗 */}
        <Route
          path={"/operation/monomer"}
          exact
          render={(props) => onEnter(Monomer, props)}
        />
        {/* 总体能耗分析 */}Collectivity
        <Route
          path={"/operation/collectivity"}
          exact
          render={(props) => onEnter(Collectivity, props)}
        />
        {/* 能耗分类配置 */}
        <Route
          path={"/operation/collocate"}
          exact
          render={(props) => onEnter(Collocate, props)}
        />
        {/* 设备分类管理 */}
        <Route
          path={"/operation/classify"}
          exact
          render={(props) => onEnter(Classify, props)}
        />
        <Route
          path={"/threeDimensional"}
          exact
          render={(props) => onEnter(ThreeDimensional, props)}
        />
        <Route
          path={"/systemSeting/processUnit"}
          exact
          render={(props) => onEnter(ProcessUnit, props)}
        />
        <Redirect from="*" to="/stationManagement/GIS" />
      </Switch>
    </HashRouter>
  </Suspense>
);

export default Routes;
